var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHammer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28066",
    "data-name": "\\uC0AC\\uAC01\\uD615 28066",
    width: 24,
    height: 24,
    transform: "translate(0 -0.398)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21823",
    "data-name": "\\uADF8\\uB8F9 21823",
    transform: "translate(-324 -290.602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21601",
    "data-name": "\\uADF8\\uB8F9 21601",
    transform: "translate(324 291)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21600",
    "data-name": "\\uADF8\\uB8F9 21600",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21599",
    "data-name": "\\uADF8\\uB8F9 21599",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28065",
    "data-name": "\\uC0AC\\uAC01\\uD615 28065",
    width: 24,
    height: 24,
    transform: "translate(0 -0.397)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21822",
    "data-name": "\\uADF8\\uB8F9 21822",
    transform: "translate(326.043 292.769)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_59",
    "data-name": "\\uC120 59",
    y1: 5.271,
    x2: 5.271,
    transform: "translate(4.9 4.702)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_60",
    "data-name": "\\uC120 60",
    y1: 5.271,
    x2: 5.271,
    transform: "translate(10.172 9.973)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_61",
    "data-name": "\\uC120 61",
    x2: 6.643,
    y2: 6.643,
    transform: "translate(13.271 12.949)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28083",
    "data-name": "\\uC0AC\\uAC01\\uD615 28083",
    width: 3.371,
    height: 12.642,
    rx: 1.685,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 0, 10.728)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28084",
    "data-name": "\\uC0AC\\uAC01\\uD615 28084",
    width: 3.371,
    height: 12.642,
    rx: 1.685,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 8.343, 2.383)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammer);
export default __webpack_public_path__ + "static/media/hammer.3bc37b1f16e9f21b2eb377b9c02b8c2c.svg";
export { ForwardRef as ReactComponent };